<script>
  import { onDestroy } from "svelte";
  import { destroySvelteComponentInstance, mountFederatedSvelteComponent } from "../lib/mountFederatedSvelteComponent";
  import OpportunityTeamsTable from "../components/opportunityTeamsTable.svelte";
  import PageContainer from "../components/shared/PageContainer.svelte";

  let el1;
  let opportunityTeamsCountInstance = null;

  const mountOpportunityTeamsCount = async () => {
    const module = await import("App/alaceOpportunityTeams/count");
    const OpportunityTeamsCount = module.default;

    if (el1) {
      opportunityTeamsCountInstance = mountFederatedSvelteComponent(
        opportunityTeamsCountInstance,
        OpportunityTeamsCount,
        { target: el1 }
      );
    }
  };

  void mountOpportunityTeamsCount();

  onDestroy(() => {
    opportunityTeamsCountInstance = destroySvelteComponentInstance(opportunityTeamsCountInstance);
  });
</script>

<PageContainer>
  <div class="grid gap-3 w-full">
    <div class="uimodule" bind:this={el1} />
    <div class="uimodule">
      <OpportunityTeamsTable />
    </div>
  </div>
</PageContainer>
